import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { AutocompleteResponse } from '../../../Repository/Otu/OtuRepository.js'
import { removeRequest } from 'Flux/FluxUtils.ts'

export interface IOtuState {
  results: string[]
  total: number
  openRequests: string[]
}

const initialState: IOtuState = {
  openRequests: [],
  results: [],
  total: -1
}

export const otuSlice = createSlice({
  name: 'otu',
  initialState,
  reducers: {
    fetchInitial: (
      state,
      action: PayloadAction<{
        orderId?: string
        projectId?: string
        query: string
        field: string
        blastType: string
      }>
    ) => {
      state.total = -1
      state.openRequests.push(action.type)
    },
    fetchInitialSuccess: (state, action: PayloadAction<AutocompleteResponse>) => {
      state.openRequests = removeRequest(state, action)
      state.results = action.payload.content
      state.total = action.payload.totalSize
    },
    fetchInitialFailure: (state, action: PayloadAction<Error>) => {
      state.openRequests = removeRequest(state, action)
    },
    fetchMore: (
      state,
      action: PayloadAction<{ orderId?: string; projectId?: string; query: string; field: string; blastType: string }>
    ) => {
      state.openRequests.push(action.type)
    },
    fetchMoreSuccess: (state, action: PayloadAction<AutocompleteResponse>) => {
      state.openRequests = removeRequest(state, action)
      state.results = [...state.results, ...action.payload.content]
    },
    fetchMoreFailure: (state, action: PayloadAction<Error>) => {
      state.openRequests = removeRequest(state, action)
    }
  }
})

export default otuSlice.reducer
